import Form from "react-bootstrap/Form";
import styles from "../../css/styles.module.css";

function HowAttend({ officeChecked, setOfficeChecked }) {
  return (
    <Form>
      <div
        key={`Submission-location-radio`}
        className="mb-3 d-flex flex-row bd-highlight"
      >
        <h6>Met with advisee : </h6> &nbsp;&nbsp;&nbsp;
        <Form.Check
          className={`${styles.form_check} `}
          checked={officeChecked == "office"}
          inline
          onChange={() => setOfficeChecked("office")}
          label="Yes"
          name="AttendLocation"
          type={"radio"}
          id={`inline-radio-1`}
        />
        <Form.Check
          className={`${styles.form_check} `}
          onChange={() => setOfficeChecked("anyPlace")}
          checked={officeChecked == "anyPlace"}
          inline
          label="No"
          name="AttendLocation"
          type={"radio"}
          id={`inline-radio-2`}
        />
      </div>
    </Form>
  );
}

export default HowAttend;
